export const FETCH_USERS = 'fetchUsers'
export const SET_LOADING = 'setLoading'
export const FETCH_USER = 'fetchUser'
export const FETCH_REPOS = 'fetchRepos'
export const SEARCH_USER = 'searchUser'